import { LoginForm, LoginFormSchema, UserSchema } from '../models/user'
import axios from 'axios'
import { ZodError } from 'zod'
import { useMutation, useQuery } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'

const ENDPOINT = '/api/auth/'

const login = async (data: LoginForm) => {
  try {
    const user = LoginFormSchema.parse(data)
    const response = await axios.post(ENDPOINT, user)
    return response.data
  } catch (error) {
    if (error instanceof ZodError) {
      throw new Error('Invalid input format. Please check your credentials.')
    } else if (axios.isAxiosError(error)) {
      if (error.response && error.status === 401) {
        throw new Error(error.response.data.message)
      }
      throw new Error('Login failed, please try again later')
    } else {
      throw new Error('An unexpected error occurred.')
    }
  }
}

const logout = async () => {
  await axios.delete(ENDPOINT)
}

const userData = async () => {
  try {
    const response = await axios.get(ENDPOINT)
    return UserSchema.parse(response.data)
  } catch (error) {
    throw new Error('User not found.')
  }
}

export const useLogin = () => {
  return useMutation({
    mutationFn: login,
  })
}

export const useLogout = () => {
  const navigate = useNavigate()

  return useMutation({
    mutationFn: logout,
    onSuccess: () => {
      navigate('/login')
      window.location.reload()
    },
  })
}

export const useUserData = () => {
  return useQuery({
    queryKey: ['user'],
    queryFn: userData,
  })
}
